export default function deepMerge(base, override) {
    const result = { ...base };
    for (const key of Object.keys(override)) {
        if (
            override[key] !== null &&
            typeof override[key] === 'object' &&
            !Array.isArray(override[key]) &&
            typeof base[key] === 'object' &&
            !Array.isArray(base[key])
        ) {
            result[key] = deepMerge(base[key], override[key]);
        } else {
            result[key] = override[key];
        }
    }
    return result;
}